import { Rect } from "../.././MyHelpers";
import { ScreenProtocolMessage } from "../../ScreenProtocol";
import { IDiamondSpinResult } from "./DiamondSpin";
import { DiamondSpinSession } from "./DiamondSpinSession";

export namespace DiamondSpinMessages {
	export class PrepareMessage extends ScreenProtocolMessage {
		public static readonly msgname = "prepare";
		public session: DiamondSpinSession = null;
		//public startConfig: IBonusStartConfig = null;

		constructor(session: DiamondSpinSession/* , startConfig: IBonusStartConfig */) {
			super(PrepareMessage.msgname);
			this.session = session;
			//this.startConfig = startConfig;
		}

	}

	export class IntroMessage extends ScreenProtocolMessage {
		public static readonly msgname = "intro";
		public session: DiamondSpinSession = null;

		constructor(session: DiamondSpinSession) {
			super(IntroMessage.msgname);
			this.session = session;
		}
	}

	export class SpinComplete extends ScreenProtocolMessage {
		public static readonly msgname = "spinComplete";

		public diamondSpinWin: IDiamondSpinResult;

		constructor(diamondSpinWin: IDiamondSpinResult) {
			super(SpinComplete.msgname);
			this.diamondSpinWin = diamondSpinWin;
		}
	} 


	export class CommetJp extends ScreenProtocolMessage
	{
		public static readonly msgname = "commetDestinationJP";
		public destRect: Rect = null;
		public srcRect: Rect = null;

		constructor(srcRect: Rect, destRect: Rect) {
			super(CommetJp.msgname);
			this.srcRect = srcRect;
			this.destRect = destRect;
			/*this.award= award; */
		} 
	}

	export class CommetJPComplete extends ScreenProtocolMessage
	{
		public static readonly msgname = "cometJp";
		constructor() {
			super(CommetJPComplete.msgname);
		} 
	}

	export class DiamondAnimation extends ScreenProtocolMessage {
		public static readonly msgname = "DiamondAnimationJPDisplay";
		public destRect: Rect = null;
		public hitJp: number = 0;

		constructor(/* srcRect: PixelRect,  */destRect: Rect, hitJp: number) {
			super(DiamondAnimation.msgname);
			this.destRect = destRect;
			this.hitJp = hitJp;
		}
	}

	export class CommeteComplete extends ScreenProtocolMessage
	{
		public static readonly msgname = "comet";
		//public diamondSpinWin: IDiamodSpinWin;
		public reel:number;

		constructor(reel:number) {
			super(CommeteComplete.msgname);
			this.reel = reel;
		} 
	}

	export class CommetDestination extends ScreenProtocolMessage {
		public static readonly msgname = "commetDestination";
		public destRect: Rect [] = [];
		/*public award:PickBonusPick = null; */

		constructor(destRect: Rect[]) {
			super(CommetDestination.msgname);
			this.destRect = destRect;
			/*this.award= award; */
		}
	}

	export class JpShowFinish extends ScreenProtocolMessage
	{
		public static readonly msgname = "JpShowFinish";

		constructor() {
			super(JpShowFinish.msgname);
		} 
	}

}